/**
 * Ref-counted `document.body` scroll lock shared by overlay surfaces (Modal,
 * Drawer). The naive "capture prev, set hidden, restore prev" pattern breaks
 * when two overlays are open at once: each captures the other's `hidden` as its
 * "previous", and whichever closes second restores `hidden` permanently —
 * sticking the page. A single module-level counter ensures the body is restored
 * only when the *last* overlay closes, regardless of close order.
 */
let depth = 0;
let prev = '';

export function lockBody() {
  if (depth === 0) prev = document.body.style.overflow;
  depth++;
  document.body.style.overflow = 'hidden';
}

export function unlockBody() {
  if (depth === 0) return; // defensive: never go negative
  depth--;
  if (depth === 0) document.body.style.overflow = prev;
}
